import { RSAA } from 'redux-api-middleware';
import { createAction } from '@bottomless/common/store';

export const SubmitByoProductTypes = createAction('Vendor', 'Submit Vendor');

export const submitByoProductAction = data => ({
  [RSAA]: {
    endpoint: 'bring-your-own-product',
    method: 'POST',
    body: data,
    types: [SubmitByoProductTypes.REQUEST, SubmitByoProductTypes.SUCCESS, SubmitByoProductTypes.FAILURE],
  },
});
